import { useState, useEffect } from "react";
import { useGetDeviceInfoLogsforReportMutation } from "../../store/storageRoles/devicesSharedApi";
import logger from "../../utils/logger";

// Bilgi değişiklik raporu yalnız depo panelinde — bayide YOK (#302).
export const useDeviceInfoReportData = (deviceId, token) => {
  const [input, setInput] = useState({
    type: "UpdateInfo",
  });
  const [date, setDate] = useState(null);
  const [dateSecond, setDateSecond] = useState(null);
  const [Datas, setDatas] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [info, setInfo] = useState(null);

  const [getDeviceInfoLogsforReport, { data, isLoading, error }] =
    useGetDeviceInfoLogsforReportMutation();

  const handleGetLogData = async (productName = null) => {
    if (!deviceId || !token || !date || !dateSecond) {
      return;
    }

    try {
      // Önceki verileri temizle
      setDatas([]);

      const requestData = {
        id: deviceId,
        createdInfo: date,
        createdInfoSecond: dateSecond,
        token: token,
      };

      const result = await getDeviceInfoLogsforReport(requestData).unwrap();

      if (result && result.data) {
        setDatas(result.data);
      }
    } catch (error) {
      logger.error("❌ Info Report Error:", error);
    }
  };

  // Data değiştiğinde Datas'ı güncelle
  useEffect(() => {
    if (data && data.data) {
      setDatas(data.data);
    }
  }, [data]);

  return {
    input,
    setInput,
    date,
    setDate,
    dateSecond,
    setDateSecond,
    Datas,
    selectedDate,
    setSelectedDate,
    info,
    setInfo,
    isLoading,
    error,
    handleGetLogData,
  };
};
